import { render, staticRenderFns } from "./ProjectGrid.vue?vue&type=template&id=31157866&scoped=true"
import script from "./ProjectGrid.vue?vue&type=script&lang=js"
export * from "./ProjectGrid.vue?vue&type=script&lang=js"
import style0 from "./ProjectGrid.vue?vue&type=style&index=0&id=31157866&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31157866",
  null
  
)

export default component.exports